module.exports = new __parcel__URL__("73091264.3df2361d.png").toString();